import { render, staticRenderFns } from "./AppBrandSettingLayout.vue?vue&type=template&id=23c2c0a4"
import script from "./AppBrandSettingLayout.vue?vue&type=script&lang=js"
export * from "./AppBrandSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports